import React from "react"
export const arrow = (
  <svg
    width="481"
    height="481"
    viewBox="0 0 481 481"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M229.325 4.104L69.325 148.104C65.933 151.176 64.013 155.464 64.013 160.008L64.013 256.008C64.0163 259.099 64.9119 262.123 66.5922 264.717C68.2724 267.311 70.6658 269.365 73.485 270.632C79.277 273.192 86.029 272.136 90.701 267.912L240.013 133.544L389.293 267.912C393.997 272.136 400.749 273.224 406.509 270.632C412.301 268.04 416.013 262.312 416.013 256.008L416.013 160.008C416.013 155.464 414.061 151.176 410.733 148.104L250.733 4.104C244.653 -1.368 235.373 -1.368 229.325 4.104V4.104Z"
        fill="black"
      />
      <path
        d="M229.325 212.104L69.325 356.104C65.933 359.176 64.013 363.464 64.013 368.008L64.013 464.008C64.0164 467.099 64.9119 470.123 66.5922 472.717C68.2724 475.311 70.6659 477.365 73.485 478.632C79.277 481.192 86.029 480.136 90.701 475.912L240.013 341.544L389.293 475.912C393.997 480.136 400.749 481.224 406.509 478.632C412.301 476.04 416.013 470.312 416.013 464.008L416.013 368.008C416.013 363.464 414.061 359.176 410.733 356.104L250.733 212.104C244.653 206.632 235.373 206.632 229.325 212.104V212.104Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="480.026"
          height="480.026"
          fill="white"
          transform="translate(1.52588e-05 480.026) rotate(-90)"
        />
      </clipPath>
    </defs>
  </svg>
)

export const trade = (
  <svg
    width="611"
    height="353"
    viewBox="0 0 611 353"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.08398 186.694L149.084 346.694C152.156 350.086 156.444 352.006 160.988 352.006L256.988 352.006C260.079 352.003 263.103 351.108 265.697 349.427C268.292 347.747 270.346 345.354 271.612 342.534C274.172 336.742 273.116 329.99 268.892 325.318L134.524 176.006L268.892 26.7265C273.116 22.0225 274.204 15.2705 271.612 9.51047C269.02 3.71847 263.292 0.00647377 256.988 0.00647323L160.988 0.00646483C156.444 0.00646443 152.156 1.95846 149.084 5.28646L5.08398 165.286C-0.388023 171.366 -0.388024 180.646 5.08398 186.694Z"
      fill="black"
    />
    <path
      d="M605.902 165.332L461.902 5.33147C458.83 1.93947 454.542 0.0194766 449.998 0.0194758L353.998 0.019459C350.908 0.0228077 347.884 0.918383 345.289 2.59862C342.695 4.27886 340.641 6.67231 339.374 9.49146C336.814 15.2835 337.87 22.0355 342.094 26.7075L476.462 176.019L342.094 325.299C337.87 330.003 336.782 336.755 339.374 342.515C341.966 348.307 347.694 352.019 353.998 352.019L449.998 352.019C454.542 352.019 458.83 350.067 461.902 346.739L605.902 186.74C611.374 180.66 611.374 171.38 605.902 165.332Z"
      fill="black"
    />
  </svg>
)
